import { Typography } from '@statsbomb/kitbag-components';

import { useFilters } from '@statsbomb/kitbag-global-football';
import { GameType } from '@statsbomb/parachute-types';
import { useTranslation } from 'react-i18next';
import { gameTypeOptions } from '@/consts/gameMetrics';
import { PERIOD_TRANSLATION_KEYS } from '@/consts/gameRange';
import { useGetGameCount } from '@/hooks/useGetGameCount';
import { OptionPromiseAtom } from '@/types/atom';
import { GamesBySeasonPromiseAtom } from '@/types/game';
import { BaseOption } from '@/types/generic';
import { getTranslatedOptions } from '@/utils/translations';

const getSelectedGameTypeOption = (options: BaseOption<string>[], selectedValue: string) =>
  options.find(option => option.value === selectedValue);

export const RadarFilterGameSummary = ({
  gamesGroupedBySeasonAtom,
  selectedGamesAtom,
}: {
  gamesGroupedBySeasonAtom: GamesBySeasonPromiseAtom;
  selectedGamesAtom: OptionPromiseAtom;
}) => {
  const { t } = useTranslation(['entity', 'filters']);
  const [
    {
      periodRange: selectedPeriodRange,
      startDate: selectedStartDate,
      endDate: selectedEndDate,
      gameType: selectedGameTypeRaw,
    },
  ] = useFilters('main');
  const selectedGameType = getSelectedGameTypeOption(getTranslatedOptions(gameTypeOptions), selectedGameTypeRaw.value);
  const { allSelected, gameCount } = useGetGameCount(selectedGamesAtom, gamesGroupedBySeasonAtom);
  const dateFromLabel = t('dateFrom', { ns: 'filters' });
  const dateToLabel = t('dateTo', { ns: 'filters' });
  const startDate = selectedStartDate ? `${dateFromLabel} ${selectedStartDate}` : '';
  const endDate = selectedEndDate ? `${dateToLabel} ${selectedEndDate}` : '';

  const { key } = selectedPeriodRange.translation;
  const period =
    key !== 'allGames' && PERIOD_TRANSLATION_KEYS.includes(key)
      ? t(key, { ns: 'filters', count: selectedPeriodRange.value })
      : null;
  const date = startDate || endDate ? `${t('dateRange', { ns: 'filters' })} ${startDate} ${endDate}`.trim() : null;
  const gameType = selectedGameType && selectedGameType.value !== GameType.HOME_AWAY ? selectedGameType.label : null;
  const count = !allSelected ? t('countSelected', { ns: 'filters', count: gameCount }) : null;

  const summaryText = [period, date, gameType, count].filter(Boolean).join(', ');

  return (
    // TODO (KC-360: Replace with Card component once available)
    <div className="bg-canvas-secondary-main px-4 py-2">
      <Typography variant="headingMedium" as="h2" className="pb-1">
        {t('game_one')}
      </Typography>
      <div className="flex gap-x-2 flex-wrap">
        <div className="flex gap-x-2 items-center w-max">
          <Typography variant="bodyRegular" as="div">
            {summaryText || t('allGames', { ns: 'filters' })}
          </Typography>
        </div>
      </div>
    </div>
  );
};
